import { useState } from "react";
import PatrimoineHistory from "./PatrimoineHistory";
import PatrimoineSource from "./PatrimoineSource";
import { useNavigate } from "react-router-dom";
import PatrimoineEquipment from "./PatrimoineEquipment";

const PatrimoineNavigationMenu = () => {
  const [activeSection, setActiveSection] = useState("histoire-de-leau");
  const navigate = useNavigate();

  const handleSectionChange = (section: any) => {
    setActiveSection(section);
    navigate(`/patrimoine?${section}`);
  };

  return (
    <>
      <div className="flex flex-col items-center mt-5 ">
        <div className="flex justify-center space-x-4">
          <div
            className={`cursor-pointer  text-xs md:text-base ${
              activeSection === "histoire-de-leau"
                ? "text-black font-bold  text-xs md:text-base  "
                : ""
            }`}
            onClick={() => handleSectionChange("histoire-de-leau")}
          >
            Histoire de l'eau
            <hr
              className={
                activeSection === "histoire-de-leau"
                  ? "bg-primary   h-1 z-10"
                  : "hidden"
              }
            />
          </div>
          <div
            className={`cursor-pointer text-xs md:text-base  ${
              activeSection === "nos-equipements"
                ? "text-black font-bold  text-xs md:text-base  "
                : ""
            }`}
            onClick={() => handleSectionChange("nos-equipements")}
          >
            Nos équipements
            <hr
              className={
                activeSection === "nos-equipements"
                  ? "bg-primary   h-1 z-10"
                  : "hidden"
              }
            />
          </div>
          <div
            className={`cursor-pointer  text-xs md:text-base ${
              activeSection === "source"
                ? "text-black font-bold  text-xs md:text-base "
                : ""
            }`}
            onClick={() => handleSectionChange("source")}
          >
            De la source au robinet 
            <hr
              className={
                activeSection === "source" ? "bg-primary   h-1 z-10" : "hidden"
              }
            />
          </div>
        </div>
        <div className="z-0 w-[420px] max-w-2xl border-t border-gray-200 dark:border-gray-800" />
      </div>

      {activeSection === "histoire-de-leau" && <PatrimoineHistory />}
      {activeSection === "nos-equipements" && <PatrimoineEquipment />}
      {activeSection === "source" && <PatrimoineSource />}
    </>
  );
};

export default PatrimoineNavigationMenu;
